import { FormOptionDto } from "src/models"
import { cn } from "src/lib/utils"

export type InputFormat = "text" | "textarea"
export interface CustomInputProps {    
  value?: string | number | null
  name: string
  label?: string
  id?: string
  placeholder?: string
  onChange?: (value: string) => void
  required? : boolean | false
  errorMessage? : string,
  customClassName?: string | null,
  maxLength? : number | 0,
  format? : InputFormat | "text"
}

const CustomInput = ({ value, name, label,  id, placeholder, required, errorMessage, customClassName, format, maxLength, onChange}: CustomInputProps) => {
    const hasError = !!errorMessage;

    return (
    <>
      {label && label.trim().length > 0 && (
        <label
          htmlFor={id || name}
          className="block text-sm font-semibold leading-6 text-gray-900"
        >
          {label}{required && <span className="text-red-500 font-bolder ml-1">*</span>}

        </label> 
      )}
    
    { (format === "text") &&
        (<input type="text"
            name={name}
            id={id || name}
            value={value ?? ""}
            onChange={(e) => onChange?.(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            className={cn( 
                (customClassName && customClassName.trim().length > 0) ? customClassName :
                `text-sm mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900  ring-inset focus:ring-2 sm:text-sm sm:leading-6`, 
                !hasError ? ` ring-1 ring-gray-300 focus:ring-indigo-600 ` : `ring-2 ring-red-300 focus:ring-red-600 `)
            }
            // className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />)
    }

    { (format === "textarea") &&
        (<textarea
            name={name}
            id={id || name}
            value={value ?? ""}
            onChange={(e) => onChange?.(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            className={cn( 
                (customClassName && customClassName.trim().length > 0) ? customClassName :
                `text-sm mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900  ring-inset focus:ring-2 sm:text-sm sm:leading-6`, 
                !hasError ? ` ring-1 ring-gray-300 focus:ring-indigo-600 ` : `ring-2 ring-red-300 focus:ring-red-600 `)
            }
            // className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />)
    }

      {hasError && (
        <span className="text-red-600 text-sm">{errorMessage}</span>
      )}
     
    </>
  )
}

export default CustomInput;